"use strict";
/**
 * AlignmentPlaceholder
 *
 * Empty-state card shown before an alignment is generated or after a
 * recoverable error.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignmentPlaceholder = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var Text_1 = require("office-ui-fabric-react/lib/Text");
var AlignmentPlaceholderComponent = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement("div", { className: "ws-alignment-placeholder" },
        react_1.default.createElement("div", { className: "placeholder-content" },
            react_1.default.createElement(Icon_1.Icon, { iconName: "FlowChart", className: "placeholder-icon" }),
            react_1.default.createElement(Text_1.Text, { variant: "large", className: "placeholder-title" }, "Alignment Graph Visualization"),
            react_1.default.createElement(Text_1.Text, { variant: "medium", className: "placeholder-text" }, text))));
};
var AlignmentPlaceholder = react_1.default.memo(AlignmentPlaceholderComponent);
exports.AlignmentPlaceholder = AlignmentPlaceholder;
AlignmentPlaceholder.displayName = "AlignmentPlaceholder";
